<template>
  <div class="userindex">
    <div v-show="mas" id="mask">
        <img src="/static/images/gyhg-end1.png"/>
        <h3>暂无积分公益，敬请期待！</h3>
        <button class="btn_fh" @click="goBack">返回</button>
    </div>
    <div  class="van-content">
      <div :style="{backgroundImage: 'url(' + toppPic + ')' }"  style="background-repeat:no-repeat;background-size:100% 100%;position: relative; " class="userbanner" >
        <p class="dotime">&nbsp;&nbsp;&nbsp;&nbsp;活动时间：{{datas1.start}}-{{datas1.end_time}}</p>
      </div>
      <van-cell-group>
          <div   class="van-cell__title title">
            <span style="font-size: 1.6rem">{{datas1.title}}</span>
          </div>
      </van-cell-group>
      <van-row class="pointAim">
        <van-col class="hasB" span="12"><div class="theme-col"><span style="font-size: 1.8rem" v-html="datas1.raise_price==null?0:datas1.raise_price"></span><span style="font-size: 1.2rem;margin-left: 5px" >积分</span> </div><div>捐赠目标</div></van-col>
        <van-col span="12"><div  class="theme-col" ><span style="font-size: 1.8rem"  v-html="datas1.sum_price==null?0:datas1.sum_price"></span><span style="font-size: 1.2rem;margin-left: 5px"  >积分</span></div><div>已筹积分</div></van-col>
      </van-row>
      <van-cell-group class="cont" >
        <h3 class="jieshao">活动介绍</h3>
        <p v-html="datas1.content">{{datas1.content}}</p>
      </van-cell-group>
      <van-row class="buttonList">
        <van-col span="12"><van-button class="moreList theme-bd theme-col" @click="giveList"  plain>爱心榜</van-button></van-col>
        <van-col span="12"><van-button class="iwill theme-bd theme-bg" @click="getJifeng"  plain>我要捐赠</van-button></van-col>
      </van-row>
    </div>
    <van-popup  style="background: transparent" v-model="show1" class="adven-popup false-popup">
      <div class="popcont">
        <img class="poplog" src='/static/images/gongyiBg.png'/>
        <div  style="overflow: hidden">
          <p style="margin-bottom: 14px;text-align: center;padding-right: 25px;font-size: 1.5rem">爱心榜</p>
          <div style="height: 60px;overflow: hidden;height: 96px;position: relative; transition: all 0.1s; margin-top:0px;">
            <div >
              <p class="scorlList" v-for="(items,index) in dataList">
                <span style="float: left">{{items.name}}</span><span  style="float: right;width: 130px;text-align: left;margin-right: 20px">捐赠了{{items.price}}积分</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup style="background: transparent" v-model="show2" class="adven-popup false-popup">
          <div class="popcont">
            <img @click="close()" class="close" src="/static/images/adventures-clear.png"/>
            <img class="poplog" src='/static/images/gongyiBg.png'/>
            <div v-if="givePoint" style="overflow: hidden">
              <h3 style="margin-bottom: 20px;text-align: center;padding-right: 25px">捐赠积分</h3>
              <h3>剩余积分：{{jifeng}}积分</h3>
              <h3 style="margin: 10px 0">捐赠积分：<input v-model="giveNum" type="text"></h3>
              <van-button @click="givePoint1" class="theme-bd theme-bg"  plain>确定</van-button>
            </div>
            <div v-if="giveSuccess"  class="giveSuccess">
              <h3 class="theme-col" style="font-size: 1.6rem">捐赠：{{giveNum}}积分</h3>
              <h3  class="theme-col" style="margin: 10px 0;">感谢您支持【{{datas1.title}}】项目!</h3>
            </div>
          </div>
    </van-popup>
  </div>
</template>

<script>
  export default {
    name: "index",
    props:['configData'],
    data () {
      return {
        datas:'',
        datas1:'',
        toppPic:'',
        show1:false,
        show2:false,
        givePoint:true,
        giveSuccess:false,
        giveNum:'',
        dream_id:'',
        part1:'',
        part2:'',
        animate:false,
        dataList:'',
        jifeng:'',
        mas:false
      }
    },
    created(){
      setInterval(this.scroll,1500)
    },
    methods:{
      goBack: function () {
        history.back(-1);
      },
      giveList:function () {
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('WebApi/Activity/Dream/dream_list', {token:isUser}, res => {
          if(res.data.errCode == '0000'){
            this.show1=true;
            this.dataList=res.data.data.dream_list
          }else{
            this.$toast(res.data.desc);
          }
        })

      },
      close:function () {
        this.show2=false;
        this.giveSuccess=false;
        this.givePoint=true;
        this.giveNum='';
      },
      getDatas:function () {
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('WebApi/Activity/Dream/index', {token:isUser}, res => {
          console.log(res.data);

          if(res.data.errCode == '0000'){
          this.datas = res.data.data
          this.datas1=res.data.data.activity
          this.toppPic=res.data.data.activity.banner_img
          this.dream_id=res.data.data.activity.id
          }else if(res.data.errCode == '5016'){
              this.mas=true
          }
          else{
            this.$toast(res.data.desc);
          }
        })
      },
      givePoint1:function () {
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('WebApi/Activity/Dream/contribution', {token:isUser,price:this.giveNum,activity_dream_id:this.dream_id}, res => {
          if(res.data.errCode == '0000'){
            this.giveSuccess=true;
            this.givePoint=false;
          }else{
            this.$toast(res.data.desc);
          }
        })
      },
      //爱心榜滚动
      scroll(){
        this.animate=true;
        if(this.dataList.length<6){
        }else{
          setTimeout(()=>{
            this.dataList.push(this.dataList[0]);
            this.dataList.shift();
            this.animate=false;
          },10)
        }

      },
      getJifeng:function () {
        this.show2=true
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('WebApi/Member/Info/index', {token:isUser}, res => {
          this.jifeng=res.data.data.memberinfo.points_usable
        })
      },

    },
    mounted () {
      this.getDatas();
    },
  }
</script>

<style lang="less" scoped>
  .userindex{
    #mask{
  z-index:999;
  background-color:#ffffff;
  position:absolute;
  top:0;
  right:0;
  width:100%;
  height:100%;
  img{
    width: 50%;
    margin: 25% 0 5% 25%;
   }
  h3{
    text-align: center;
    font-size: 16px;
    margin-bottom: 20px;
  }
  .btn_fh{
    width:50%;
    margin:0 25%;
    background-color:#df0303;
    color:#fff;
    height:50px;
    font-size:20px;
    text-align:center;
    border-radius:10px;
    line-height:50px;
  }
}
    .listAll{
      position: absolute;
      top:0;
    }
    .scorlList{
      overflow: hidden;

    }
    #slide{
      background: #fff;
      position:absolute;height:300px;width:260px;color:#FA8E93;overflow:hidden;border:1px solid #ccc;
      top:0;
      left:0;
      p{height:34px;line-height:34px;overflow:hidden}
      span{float:left}
    }
    .dotime{
      padding:6px 0;
      background: rgba(0,0,0,.6);
      color: #fff;
      position: absolute;
      bottom: 0;
      width: 100%;
    }
    .popcont{
      width: 210px;
      height: 160px;
      border-radius: 8px;
      position: relative;
      background: #fff;
      text-align: center;
      padding: 40px 0px 0 25px;
      .close{
        width: 20px;
        position: absolute;
        bottom: -45px;
        left: 50%;
        margin-left: -10px;
      }
      .poplog{
        width: 60px;
        height: 60px;
        position: absolute;
        top:-30px;
        left:50%;
        margin-left: -30px;
      }
      input{
        height: 25px;
        width: 102px;
        border-radius: 4px;
        padding: 0 5px;
      }
      h3{
        text-align: left;
        margin-bottom: 5px;
        font-weight: normal;
        font-size: 1.3rem;
      }
      .van-button{
        width: 184px;
        height: 35px;
        line-height: 32px;
        float: left;
        border-radius: 6px;
      }
      .giveSuccess{
        padding-right: 25px;
        margin-top: 30px;
        h3{
          text-align: center;

        }
      }
    }
    .van-card__title{
      font-size: 16px;
    }
    .van-card__row describe{
      font-size: 14px;
    }
    .van-content{
      padding-top: 0;
    }
    .userbanner{
      height: 190px;
      position: relative;
    }
    .van-cell:not(:last-child)::after{
      left: 0;
    }
    .userOrder{
      position: relative;
    }
    .van-cell-group,.van-cell{
      background: #fff;
    }
    .ordercell{
      img{
        width: 25px;
        height: auto;
        margin-bottom: 5px;
      }
    }
    .van-cell-group{
      .van-cell__title{
        img{
          width: 30px;
          margin-right: 5px;
        }
      }
    }
    .pointAim{
      margin-top: 8px;
      border-top:1px solid #ddd;
      .van-col--12 {
        text-align: center;
        height: 18vw;
        padding: 4%;
        background-color: #fff;
        position: relative;
        p{
          text-align: center!important;
          width: 70px;
          position: absolute;
          left: 50%;
          margin-left: -35px;
        }
      }
      .hasB{
        position: relative;
      }
      .hasB:after{
        content: '';
        position: absolute;
        right: 0;
        top:10px;
        width: 1px;
        height: 47.5px;
        background-color: #ddd;
      }
    }
    .cont{
      margin-top: 8px;
      padding: 0 15px 15px 15px;
      .jieshao{
        padding: 10px 0;
        font-size: 1.7rem;
        font-weight: normal;
      }
    }



    .van-cell-group {
      margin-bottom: 0px;
      border-bottom: 1px solid #EEEEEE;
    }
    .describe{
      height: 40px;
      line-height: 20px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp:2;
      overflow: hidden;
    }
    .title{
      padding: 20px 15px 20px 70px;
      background-image: url(/static/images/gongyiTitle.png);
      background-size: 110% 100%;
      background-repeat: no-repeat;
    }
    .buttonList{
      background: #fff;
      width: 100%;
      position: fixed;
      bottom: 0;
      left:0;
      text-align: center;
      padding: 10px 0;
      .van-button{
        height: 35px;
        line-height: 35px;
        width: 88%;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/user/do/nodo.vue